import { Injectable, inject } from '@angular/core';
import { AppStateService } from './app-state.service';
import { UserRoleService } from './user-role.service';
import { ConfigService } from 'src/config';

type HasAccessResponse = Record<'TaWriter' | 'TemplateEditor', boolean>;

@Injectable({
  providedIn: 'root'
})
export class TrafficDeviationAccessService {
  private readonly appStateService = inject(AppStateService);
  private readonly userRoleService = inject(UserRoleService);
  private readonly configService = inject(ConfigService);


  constructor() {}

  public async isTrafficDeviationEnabled(garageCode: string): Promise<boolean> {
    const hastusRegionCode = this.appStateService.stateSnapshot.garages.find(g => g.code === garageCode)?.hastusRegionCode;
    return (await this.userRoleService.isTaWriter()) && this.isTrafficDeviationRegion(hastusRegionCode);
  }

  public async hasAccess(): Promise<HasAccessResponse> {
    // User has access to Traffic Deviation if the user is a TA Writer and the user has a garage in a region with traffic deviation.
    // User has access to Template Editor if the user is a TA Template Editor.

    const [isTaWriter, isTaTemplateEditor] = await Promise.all([
      this.userRoleService.isTaWriter(),
      this.userRoleService.isTaTemplateEditor()
    ]);

    const accesses = {
      'TaWriter': isTaWriter,
      'TemplateEditor': isTaTemplateEditor
    };

    return accesses;
  }

  public hasTrafficDeviationRegion(hastusRegionCodes: string[]): boolean {
    return hastusRegionCodes.some((code) => this.isTrafficDeviationRegion(code));
  }

  public isTrafficDeviationRegion(hastusRegionCode: string): boolean {
    const developmentEnvironments = ['dev', 'test', 'utv'];

    const hastusRegionCodesWithTrafficDeviation = developmentEnvironments.includes(
      this.configService.environmentName.toLowerCase()
    ) ? ['HUB', 'NAV', 'TYR', 'SOD'] : ['HUB', 'NAV', 'TYR'];
    
    return hastusRegionCodesWithTrafficDeviation.includes(hastusRegionCode);
  }
}